import { parseDateIgnoreTimezone } from "utils/moment-utils";

enum UnavailabilityReason {
    Unknown = 0,
    MaxConcurrentBookingsExceeded = 1,
    MaxConcurrentGuestsExceeded = 2,
    IsClosed = 3,
    ResourcesAreBooked = 4,
    LockTimeHasPassed = 5,
    NoBookableResources = 6,
}

class Unavailability {
    from: number | null;
    to: number | null;
    reason: UnavailabilityReason;

    constructor(values?: Partial<Unavailability>) {
        this.from = values?.from ?? null;
        this.to = values?.to ?? null;
        this.reason = values?.reason ?? UnavailabilityReason.Unknown;
    }
}

export class TimeSlot {
    name: string;
    title: string;
    ruleId: number;
    unavailability: Unavailability[];
    start: IMoment;
    end: IMoment;
    availableUntil: IMoment;
    availableSeats: number[];
    waitListSeats: number[] | null;
    /** Warning, this value is undefined, use the parent (WebRule recoup time) instead */
    recoupTime?: number | null;

    timeExpired: boolean;
    unavailableForGroupSize?: boolean;
    waitListUnavailableForGroupSize?: boolean;

    constructor(values?: Partial<TimeSlot>) {
        this.name = values?.name ?? "";
        this.title = values?.title ?? "";
        this.ruleId = values?.ruleId ?? 0;
        this.unavailability = values?.unavailability?.map((u) => new Unavailability(u)) ?? [];
        this.start = parseDateIgnoreTimezone(values?.start);
        this.end = parseDateIgnoreTimezone(values?.end);
        this.availableUntil = parseDateIgnoreTimezone(values?.availableUntil);
        this.availableSeats = values?.availableSeats ?? [];
        this.waitListSeats = values?.waitListSeats ?? null;

        this.timeExpired = values?.timeExpired ?? false;
        this.unavailableForGroupSize = values?.unavailableForGroupSize ?? false;
        this.waitListUnavailableForGroupSize = values?.waitListUnavailableForGroupSize ?? false;
    }
}
